import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wells-requests-tab',
    templateUrl: './wells-requests-tab.component.html',
    styleUrls: ['./wells-requests-tab.component.scss'],
    standalone: false
})
export class WellsRequestsTabComponent implements OnInit {
    public requests: any[] = [];
    public loading: boolean = false;
    public error: string = '';
    
    // Pagination Properties
    public paginatedRequests: any[] = [];
    public currentPage: number = 1;
    public pageSize: number = 20;
    public totalPages: number = 1;
    public Math = Math;

    constructor() { }

    ngOnInit(): void {
        // No data to show for now - will be implemented when API is available
        this.updatePaginatedRequests();
    }

    /**
     * Updates the paginated requests array based on current page
     */
    public updatePaginatedRequests(): void {
        this.totalPages = Math.ceil(this.requests.length / this.pageSize);
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.paginatedRequests = this.requests.slice(startIndex, endIndex);
    }

    /**
     * Navigate to specific page
     */
    public goToPage(page: number): void {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
        this.updatePaginatedRequests();
    }

    /**
     * Go to next page
     */
    public nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.updatePaginatedRequests();
        }
    }

    /**
     * Go to previous page
     */
    public prevPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.updatePaginatedRequests();
        }
    }

    /**
     * Handle page size change
     */
    public onPageSizeChange(): void {
        this.currentPage = 1;
        this.updatePaginatedRequests();
    }
}
